import React from 'react';
import type { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import type { HeaderTitleAlign } from '../components/HeaderTitle';

type HeaderState = {
    primary: boolean;
    colorScheme: ColorScheme;
    titleAlign: HeaderTitleAlign;
};

const HeaderStateContext = React.createContext<HeaderState | undefined>(undefined);

interface HeaderContextProviderProps {
    children: React.ReactNode;
    state: HeaderState;
}

const HeaderContextProvider = (props: HeaderContextProviderProps) => {
    const { children, state } = props;
    return <HeaderStateContext.Provider value={state}>{children}</HeaderStateContext.Provider>;
};

const useHeaderState = () => {
    const headerState = React.useContext(HeaderStateContext);
    if (typeof headerState === 'undefined') {
        throw new Error('useHeaderState must be used within a HeaderContextProvider');
    }
    return headerState;
};

export { HeaderContextProvider, useHeaderState };
